module.exports = __webpack_public_path__ + "img/display.fb613f5e.svg";